import { KeenIcon } from '@/components'
import { formatCurrency } from '@/utils';
import {Skeleton} from '@/components/ui/skeleton'

// Plain words with a hover explanation: "Billed" on its own confused attorneys (OL-141).
const ContactMatterBillingSummary = ({ paymentData, loading }) => {
    const { paid, due, billed } = paymentData
    const billingData = [
        {
            title: 'Paid',
            value: paid,
            icon: 'dollar',
            hint: 'Payments and settlements received on invoices.',
        },
        {
            title: 'Due',
            value: due,
            icon: 'price-tag',
            hint: 'Still owed on approved and billed invoices.',
        },
        {
            title: 'Invoiced',
            value: billed,
            icon: 'bill',
            hint: 'Total of invoices sent to the client.',
        }
    ]

    return (
        <div className='flex items-center justify-between max-sm:flex-wrap gap-2.5 mb-2'>
            {billingData.map((item, index) => (
                <div className={`card sm:w-1/3 w-full`} key={index} title={item.hint}>
                    <div className='flex items-center justify-between w-full text-base card-body'>
                        <div className='flex items-center gap-1.5'>
                            <KeenIcon icon={item.icon} />
                            {item.title}
                        </div>
                        <div>
                            {loading ? 
                            <Skeleton className='w-[75px] h-[14px]' />
                            :
                            formatCurrency(item.value)
                            }
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export { ContactMatterBillingSummary }
